(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/views/parts/rows-display.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/views/parts/rows-display.js');
"use strict";

const {
  useContext
} = React;
const {
  useSelector
} = ReactRedux;
const {
  selectSystemSize,
  selectReduceCount,
  selectNumberOfCompletedBoards
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  RowsDisplayView
} = svs.components.tipsen.betslip.views.parts;
const RowsDisplay = _ref => {
  let {
    isReduced = false
  } = _ref;
  const {
    couponId
  } = useContext(BetslipContext);
  const completedBoards = useSelector(state => selectNumberOfCompletedBoards(state, couponId));
  const selectedSystemSize = useSelector(state => selectSystemSize(state, couponId, 0));
  const reducedCount = useSelector(state => selectReduceCount(state, couponId));
  const numRows = isReduced ? reducedCount : completedBoards;
  const currentEngine = useSelector(selectEngineDefinition);
  const isGoalCount = currentEngine.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;
  const goalCountNumRows = completedBoards > 0 ? selectedSystemSize : 0;
  const numberOfRows = isGoalCount ? goalCountNumRows : numRows;
  return React.createElement(RowsDisplayView, {
    isReduced: isReduced,
    numberOfRows: numberOfRows,
    numRows: numRows,
    selectedSystemSize: selectedSystemSize
  });
};
setGlobal('svs.components.tipsen.betslip.views.parts.RowsDisplay', RowsDisplay);

 })(window);